import React, { Component } from "react";
import { connect } from "react-redux";
import { MobileComponent } from "./MobileComponent";
import MatspecContainer from "./Matspec/MatspecContainer";
import HeaderContainer from "./Header/HeaderContainer";
import CreativeContainer from "./Creative/CreativeContainer";
import DetailsContainer from "./Details/DetailsContainer";
import SplashContainer from "./Splash/SplashContainer";
import { Tabs, Spin } from "antd";
import {
  getBooking,
  setCurrentTab,
  getConfiguration,
  getLanguage
} from "./../../redux/actions/index";
import "./Mobile.css";
import { getParamFromUrl } from "../Helpers";

const { TabPane } = Tabs;

const mapStateToProps = state => {
  return {
    booking: state.booking,
    currentMatspec: state.currentMatspec,
    currentTab: state.currentTab,
    currentCreative: state.currentCreative,
    configuration: state.configuration,
    language: state.language,
    bookingType: state.bookingType
  };
};
const mapDispatchToProps = dispatch => {
  return {
    getBooking: val => dispatch(getBooking()),
    setCurrentTab: key => dispatch(setCurrentTab(key)),
    getConfiguration: () => dispatch(getConfiguration()),
    getLanguage: (langCode, saveAudit) =>
      dispatch(getLanguage(langCode, saveAudit))
  };
};

class Mobile extends Component {
  setInitialLanguage = () => {
    const { getLanguage } = this.props;
    const IXMobileLangCode = localStorage.getItem("IXMobileLangCode");
    const langParam = getParamFromUrl(window.top.location.href, "language");
    if (IXMobileLangCode) getLanguage(IXMobileLangCode, true);
    else if (langParam) getLanguage(langParam.toUpperCase(), true);
    else getLanguage("EN", true);
  };
  componentDidMount() {
    getConfiguration();
    this.setInitialLanguage();
  }

  render() {
    const {
      booking,
      currentMatspec,
      currentTab,
      currentCreative,
      language,
      bookingType
    } = this.props;
    const printedMatspecs =
      booking && booking.matspecs.filter(matspec => matspec.printed);
    const digitalMatspecs =
      booking && booking.matspecs.filter(matspec => !matspec.printed);
    if (booking)
      return (
        <MobileComponent>
          {booking && <SplashContainer />}
          <HeaderContainer />
          <Tabs
            activeKey={currentTab}
            className="mobile--container--tabs"
            onTabClick={key => this.props.setCurrentTab(key)}
          >
            {(bookingType === "DIGITAL" || bookingType === "DIGITAL_PRINTED") &&
              (currentTab === "1" || currentTab === "2") && (
                <TabPane tab={<span>{language.data.digital}</span>} key="1">
                  {digitalMatspecs.map((matspec, index) => (
                    <MatspecContainer key={index} matspec={matspec} />
                  ))}
                </TabPane>
              )}
            {(bookingType === "PRINTED" || bookingType === "DIGITAL_PRINTED") &&
              (currentTab === "1" || currentTab === "2") && (
                <TabPane
                  tab={<span>{language.data.print}</span>}
                  key={bookingType === "PRINTED" ? "1" : "2"}
                >
                  {printedMatspecs.map((matspec, index) => (
                    <MatspecContainer key={index} matspec={matspec} />
                  ))}
                </TabPane>
              )}
            {currentMatspec && currentTab === "3" && (
              <TabPane tab={<span>Matspec {currentMatspec.name}</span>} key="3">
                {currentMatspec.admaterial.map((admaterial, key) => (
                  <CreativeContainer key={key} admaterial={admaterial} />
                ))}
              </TabPane>
            )}
            {currentCreative && currentTab === "4" && (
              <TabPane
                tab={
                  <span>
                    {currentMatspec.printed
                      ? "Matspec " + currentMatspec.name
                      : "Creative " + currentCreative.id}
                  </span>
                }
                key="4"
              >
                <DetailsContainer admaterial={currentCreative} />
              </TabPane>
            )}
          </Tabs>
        </MobileComponent>
      );
    return (
      <Spin style={{ margin: "auto", padding: "50px", display: "block" }} />
    );
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Mobile);



// WEBPACK FOOTER //
// ./src/components/Mobile/MobileContainer.js